var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );




var shim = require("/var/www/django/robot-artist.ru/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/pages/Index/PaintingsPopup.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/pages/Index/PaintingsPopup.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n<div class=\"PaintingsPopup\">\n    <div class=\"PaintingsPopup-BG\"></div>\n\n    <h1 class=\"PaintingsPopup-headerMobile\"></h1>\n\n    <div class=\"PaintingsPopup-scrollBox\">\n        <div class=\"PaintingsPopup-content\">\n            <div class=\"PaintingsPopup-contentInner\">\n                <div class=\"PaintingsPopup-close\">\n                    <div class=\"l1\"></div>\n                    <div class=\"l2\"></div>\n                </div>\n                <h1 class=\"PaintingsPopup-headerDesktop\"></h1>\n                <div class=\"PaintingsPopup-contentWrapperOuter\">\n                    <div class=\"u-fadeTop\"></div>\n                    <div class=\"u-fadeBottom u-fadeBottom--left\"></div>\n                    <div class=\"u-fadeBottom\"></div>\n                    <div class=\"u-fadeBottom u-fadeBottom--right\"></div>\n                    <div class=\"u-corner u-corner--top\"></div>\n                    <div class=\"u-corner u-corner--right\"></div>\n                    <div class=\"u-corner u-corner--bottom\"></div>\n                    <div class=\"u-corner u-corner--left\"></div>\n                    <div class=\"PaintingsPopup-contentWrapper\"></div>\n                </div>\n            </div>\n        </div>\n    </div>\n\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/pages/Index/PaintingsPopup.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/Index/PaintingsPopup.jinja
// module id = 52
// module chunks = 0